// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__W7JAV","amount":"Amount_amount__5_6VN","tip":"Amount_tip__2GIa-","tipHeader":"Amount_tipHeader__1I1lG","tipsWrap":"Amount_tipsWrap__1Bg4J"};